let site = "currentSite"
let siteName = "szenes"
import { getSiteId } from "./animation.js";

getSiteId(site, siteName);